export const setFilter1 = (value) => {
  return { type: "SET_FILTER_1", value: value }
}

export const setFilter2 = (value) => {
  return { type: "SET_FILTER_2", value: value }
}
